// You can include shared interfaces/types in a separate file
// and then use them in any component by importing them. For
// example, to import the interface below do:
//
// import { User } from 'path/to/interfaces';

export type HubColors = {
  primary: string;
  background: string;
  foreground: string;
}
export const DefaultHubColors: HubColors = {
  primary: "#95C631",
  background: "#212121",
  foreground: "#FFFFFF",
}

export type HubType = 'standard' | 'catalogue'
export type Hub = {
  id: string
  producer_id: string
  name: string
  code: string
  description: string
  type: HubType
  events: Event[]
  producer: Producer
  inserted_at: string
  updated_at: string
  primary_color_hex: string
  background_color_hex: string
  text_color_hex: string
  cover_image_url?: string
}

export type HubEvent = {
  id: string
  hub_id: string
  event_id: string
}

export type Producer = {
  id: string
  name: string
  contact_email: string
  avatar_url?: string
  created_by_user_id: string
}

export type EventVisibility = 'visible' | 'hidden';
export type EventType = 'standard' | 'sessioned' | 'session';
export type EventAdminStatus = 'submitted' | 'live' | 'pendingPayout' | 'past';

export type EventImage = {
  blurhash?: string;
  url: string;
}

export type Venue = {
  name: string;
  address?: string;
}

export type TicketType = {
  name: string;
  max_sales?: number;
  price: number;
  on_sale_from?: Date;
  on_sale_until?: Date;
}

export type Event = {
  id: string
  firebase_id?: string
  title: string
  slug?: string
  start_time: string
  end_time?: string
  short_description: string
  venue: Venue;
  long_description: string;
  images: EventImage[];
  ticket_types: TicketType[];
  visibility: EventVisibility;
  type: EventType;
  parent_event_id?: string;
  minimum_years_of_age?: number;
  collect_postcode?: boolean;
  capacity?: number;
  archived?: boolean;
  stripe_product_id?: string;
  admin_status?: EventAdminStatus;
  payout_account_id?: string;
  share_url?: string;
}

export const hubFromSupabase = (data: any) => {
  const events = (data.hub_events ?? []).map((hubEvent: any) => eventFromSupabase(hubEvent.events))
  const producer = producerFromSupabase(data.producers);

  return {
    id: data.id,
    producer_id: data.producer_id,
    name: data.name,
    code: data.code,
    description: data.description,
    type: data.type,
    events: events,
    producer: producer,
    inserted_at: data.inserted_at,
    updated_at: data.updated_at,
    primary_color_hex: data.primary_color_hex,
    background_color_hex: data.background_color_hex,
    text_color_hex: data.text_color_hex,
    cover_image_url: data.cover_image_url,
  } as Hub
}

export const eventFromSupabase = (data: any) => {
  return {
    id: data.id,
    firebase_id: data.firebase_id,
    title: data.title,
    slug: data.slug,
    start_time: data.start_time,
    end_time: data.end_time,
    short_description: data.short_description,
    long_description: data.long_description,
    venue: data.event_venues[0],
    images: data.event_images,
    ticket_types: data.event_ticket_types,
    visibility: data.visibility,
    type: data.type,
    minimum_years_of_age: data.minimum_years_of_age,
    collect_postcode: data.collect_postcode,
    capacity: data.capacity,
    archived: data.archived,
    payout_account_id: data.payout_account_id,
    admin_status: data.admin_status,
  } as Event
}

export const producerFromSupabase = (data: any) => {
  return {
    id: data.id,
    name: data.name,
    contact_email: data.contact_email,
    avatar_url: data.avatar_url,
    created_by_user_id: data.created_by_user_id,
  } as Producer
}
